import styled from 'styled-components';
import React from 'react';
import { MainRouter } from 'core/routers';

const LayoutStyled = styled.div`
  background: transparent;
  height: 100vh;
  display: flex;
  flex-direction: column;

  & .Mui-focused {
    & .MuiSelect-icon,
    & .MuiSelect-iconOpen {
      fill: ${({ theme }) => theme.colors.brand01};
    }
  }
`;

export const Layout = () => {
  return (
    <LayoutStyled>
      <MainRouter />
    </LayoutStyled>
  );
};
